import { List, ListSubheader, Typography } from "@mui/material";
import { ReactNode } from "react";

type Props = {
  group: string;
  children: ReactNode;
};

const AutocompleteGroupedList = ({ group, children }: Props) => (
  <>
    <ListSubheader
      disableSticky
      sx={{
        color: "primary.light",
        fontWeight: 600,
        textTransform: "uppercase",
        lineHeight: "20px",
      }}
    >
      <Typography variant="header">{group}</Typography>
    </ListSubheader>
    <List sx={{ paddingLeft: "32px" }}>{children}</List>
  </>
);

export default AutocompleteGroupedList;
